import { Style, Stroke, Fill, Circle as CircleStyle } from 'ol/style';
import { DEFAULT_POINT_COLOR, DEFAULT_FOOTPRINT_COLOR } from '@config/droneImagesLayerConfig';

/**
 * Create simple point style for image locations
 *
 * @param {Object} colorRgba - Color object with r, g, b, a properties
 * @param {boolean} isHighlighted - Whether the point is highlighted
 * @returns {Style} OpenLayers style
 */
export const createPointStyle = (colorRgba = DEFAULT_POINT_COLOR, isHighlighted = false) => {
	const color = `rgba(${colorRgba.r}, ${colorRgba.g}, ${colorRgba.b}, ${colorRgba.a})`;
	const radius = isHighlighted ? 7 : 4;

	return new Style({
		image: new CircleStyle({
			radius,
			fill: new Fill({ color }),
			stroke: new Stroke({
				color: '#ffffff',
				width: isHighlighted ? 2 : 1,
			}),
		}),
	});
};

/**
 * Create polygon style for image footprints
 *
 * @param {Object} colorRgba - Color object with r, g, b, a properties
 * @returns {Style} OpenLayers style
 */
export const createFootprintStyle = (colorRgba = DEFAULT_FOOTPRINT_COLOR) => {
	return new Style({
		stroke: new Stroke({
			color: `rgba(${colorRgba.r}, ${colorRgba.g}, ${colorRgba.b}, 1)`,
			width: 2,
		}),
		fill: new Fill({
			color: `rgba(${colorRgba.r}, ${colorRgba.g}, ${colorRgba.b}, 0.2)`,
		}),
	});
};
